import { FormStepSections } from '@features/onboarding/enums/formSections.enum';

export const MARKETPLACE_TAGS = [
  {
    label: 'YOU',
    value: 'primary',
  },
  {
    label: 'SPOUSE',
    value: 'spouse',
  },
  {
    label: 'CHILD',
    value: 'dependent',
  },
];

export const IDENTITY_PROTECTION_PLANS = [
  {
    id: 'identity-protection-lifelock-essential-plan',
    title: 'LifeLock Essential',
    description:
      'This plan provides basic identity theft protection, including credit monitoring, identity alerts, and stolen funds reimbursement to help safeguard your personal and financial information.',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
    image: '/images/lifelock-logo.png',
    price: '$3.67',
    period: 'per period',
    sectionName: FormStepSections.Summary,
  },
  {
    id: 'identity-protection-lifelock-premier-plan',
    title: 'LifeLock Premier',
    description:
      'This plan provides basic identity theft protection, including credit monitoring, identity alerts, and stolen funds reimbursement to help safeguard your personal and financial information.',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
    image: '/images/lifelock-logo.png',
    price: '$3.88',
    period: 'per period',
    sectionName: FormStepSections.Summary,
  },
];

export const LEGAL_PLANS = [
  {
    id: 'legal-shield-basic',
    title: 'Legal Shield Basic',
    description:
      'Speak with a lawyer on an unlimited number of personal legal issues. Legal Shield Basic is perfect for single people.',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
    image: '/images/shield.png',
    price: '$2.45',
    period: 'per period',
    sectionName: FormStepSections.Summary,
  },
  {
    id: 'legal-lifelock-premier-plan',
    title: 'Legal Shield Advanced',
    description:
      'Speak with a lawyer on an unlimited number of personal legal issues and get enhanced legal support for your entire family.',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
    image: '/images/shield.png',
    price: '$2.82',
    period: 'per period',
    sectionName: FormStepSections.Summary,
  },
];

export const TELEHEALTH_PLANS = [
  {
    id: 'doctegrity-telehealth-plan',
    title: 'Doctegrity Telehealth plan',
    description:
      'Doctegrity Telehealth provides 24/7 access to licensed doctors and mental health professionals from anywhere',
    content:
      'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.',
    image: '/images/telehealth-logo.png',
    price: '$4.62',
    period: 'per period',
    sectionName: FormStepSections.Summary,
  },
];
